import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { LoginCallback } from '@okta/okta-vue';
import Logout from '@/app/shared/components/Logout.vue';
import PageNotFound from '@/app/shared/components/PageNotFound.vue';
import { getAmsRoutes } from './app/features/ams/router';
import { getAdminRoutes } from './app/features/admin/router';
import { getBaseRoutes } from './app/features/base/router';
import LoginForm from './app/features/auth/pages/LoginForm.vue';
import { formLoginGuard, oktaLoginGuard } from './app/shared/guards/auth-guard';

const routes: Array<RouteRecordRaw> = [
  ...getBaseRoutes('/'),
  ...getAmsRoutes('/ams'),
  ...getAdminRoutes('/admin'),
  {
    path: '/login',
    name: 'login',
    component: LoginForm,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login/callback',
    component: LoginCallback,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: PageNotFound,
    meta: {
      title: 'PageNotFound',
    },
  },
];

const baseURL = config?.VUE_APP_BASE_PATH || '/';

const router = createRouter({
  history: createWebHistory(baseURL),
  routes,
});

router.beforeEach(formLoginGuard);
router.beforeEach(oktaLoginGuard);

export default router;
